<template>
  <AssayDescriptionGrid :dv="dv" :fields="fields" />
</template>

<script>
import AssayDescriptionGrid from './AssayDescriptionGrid.vue'

const fields = [
  ['name'],
  ['nr_of_samples', 'id'],
  ['widget:instrumentData'],
  ['slot:fc:run_dir'],
  ['description'],
  ['protocol_list'],
]

export default {
  name: 'AssayDescription',
  components: {
    AssayDescriptionGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup() {
    return { fields }
  },
}
</script>
